<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="WorksheetList"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <VueSlickgrid
    name="worksheets"
    :headerTitle="'Worksheets'|gettext"
    :items="ds"
    checkbox-row-selection
    :columnDefaults="b_2248226175642056_columnDefaults"
    :columns="b_2248226175642056_columns"
    class="page--grid"
    ref="grid"
    @selectedRowsChanged="evh_2248226175642056_selectedRowsChanged($event, {})"
  >
    <DIV
      class="flex-grow-1 d-flex"
      slot="toolbar"
    >
      <ItpButton
        :icon="$config.worksheet.createWorksheetIcon"
        :text="'New worksheet...'|gettext"
        size="sm"
        variant="light"
        class="mx-2"
        @click="evh_6466705138206980_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        icon="fa-trash"
        :text="'Delete'|gettext"
        size="sm"
        variant="light"
        :disabled="!selectedItems || !selectedItems.length"
        :spinning="actions.deleteItems.isRunning"
        class="mx-2"
        @click="evh_8320016629450276_click($event, {})"
      >
      </ItpButton>
      <PageHelp
        path="/worksheets/worksheets.html"
      >
      </PageHelp>
    </DIV>
  </VueSlickgrid>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "worksheets",
    path: "/worksheets",
    component: "WorksheetList"
  }
)

@Component()
export default class WorksheetList extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  selectedItems!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('integro_api/list_worksheet')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2248226175642056_columnDefaults!: any;
  b_2248226175642056_columns!: any;
  dataMembers = ['selectedItems', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        selectedItems: [
        ]
        ,
        ds: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2248226175642056_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
        }
        ,
        b_2248226175642056_columns: [{
          field: "number",
          name: this.$fn.pgettext("Worksheets", "Number"),
          type: "command",
          width: "200px",
          formatter: {
            name: "routeLink",
            to: "worksheet",
            params: {
              id: "id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "status",
          name: this.$fn.pgettext("Worksheets", "Status"),
          width: "150px",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "gettext",
              context: "WorksheetStatus",
              conversion: "StartCase",
              filterInput: true,
            }
              ,
            {
              name: "statusDot",
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "worksheet_date",
          name: this.$fn.pgettext("Worksheets", "Date"),
          type: "date",
        }
          ,
        {
          field: "description",
          width: "200px",
          name: this.$fn.pgettext("Worksheets", "Description"),
        }
          ,
        {
          field: "rental_name",
          name: this.$fn.pgettext("Worksheets", "Rental"),
          type: "command",
          formatter: {
            name: "routeLink",
            to: "rental",
            navigateOnIconClick: true,
            params: {
              id: "rental_id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "company_name",
          name: this.$fn.pgettext("Worksheets", "Company"),
          formatter: {
            name: "routeLink",
            to: "company",
            navigateOnIconClick: true,
            params: {
              id: "company_id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "client_name",
          width: "200px",
          name: this.$fn.pgettext("Worksheets", "Client"),
          formatter: {
            name: "routeLink",
            to: "company",
            navigateOnIconClick: true,
            params: {
              id: "client_id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "contractor_name",
          width: "200px",
          name: this.$fn.pgettext("Worksheets", "Contractor"),
          formatter: {
            name: "routeLink",
            to: "company",
            navigateOnIconClick: true,
            params: {
              id: "contractor_id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "created_at",
          name: this.$fn.pgettext("BrowserColumn", "Create time"),
          formatter: "datetime",
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.gettext("Worksheets"),
        icon: this.$config.worksheet.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_5754_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_5754, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_setData_5756_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2248226175642056_setData_5756, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_2248226175642056_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_6466705138206980_showModal_5758_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_6466705138206980_showModal_5758, alias=undefined
    return {
      name: "Worksheet",
      props: {
        size: "lg",
      }
      ,
    }
  }

  async evh_6466705138206980_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6466705138206980_click.executeFromDOM(this, event, scope);
  }

  async act_8320016629450276_reloadSlickgrid_5762_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8320016629450276_reloadSlickgrid_5762, alias=undefined
    return {
      grid: "worksheets",
    }
  }

  async act_8320016629450276_request_5760_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_8320016629450276_request_5760, alias=deleteItems
    return {
      operation: "delete_worksheets",
      data: { worksheets: this.selectedItems.map(p => p.id) },
    }
  }

  async evh_8320016629450276_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_5754: actions.CloseModalAction;
    evh_7315092382398562_close_5753: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_setData_5756: actions.SetDataAction;
    evh_2248226175642056_selectedRowsChanged_5755: actions.EventHandlerImpl;
    evh_2248226175642056_selectedRowsChanged: actions.EventHandlerGroup;
    act_6466705138206980_showModal_5758: actions.ShowModalAction;
    evh_6466705138206980_click_5757: actions.EventHandlerImpl;
    evh_6466705138206980_click: actions.EventHandlerGroup;
    act_8320016629450276_reloadSlickgrid_5762: actions.ReloadSlickgridAction;
    evh_8320016629450276_success_5761: actions.EventHandlerImpl;
    act_8320016629450276_request_5760: actions.RequestAction;
    evh_8320016629450276_click_5759: actions.EventHandlerImpl;
    evh_8320016629450276_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_5754 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_5754_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_5753 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_5754,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_5753],
      }
    );
    const act_2248226175642056_setData_5756 = new actions.SetDataAction(
      {
        actionArgs: this.act_2248226175642056_setData_5756_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_selectedRowsChanged_5755 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_setData_5756,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_2248226175642056_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_selectedRowsChanged_5755],
      }
    );
    const act_6466705138206980_showModal_5758 = new actions.ShowModalAction(
      {
        actionArgs: this.act_6466705138206980_showModal_5758_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_click_5757 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_showModal_5758,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_6466705138206980_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_6466705138206980_click_5757],
      }
    );
    const act_8320016629450276_reloadSlickgrid_5762 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8320016629450276_reloadSlickgrid_5762_getActionArgs,
        events: [],
      }
    );
    const evh_8320016629450276_success_5761 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_reloadSlickgrid_5762,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_8320016629450276_request_5760 = new actions.RequestAction(
      {
        actionArgs: this.act_8320016629450276_request_5760_getActionArgs,
        displayName: "deleteItems",
        events: [evh_8320016629450276_success_5761],
      }
    );
    const evh_8320016629450276_click_5759 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_request_5760,
        event: "click",
        displayName: "deleteItems",
      }
    );
    const evh_8320016629450276_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_click_5759],
      }
    );
    return {
      act_7315092382398562_closeModal_5754,
      evh_7315092382398562_close_5753,
      evh_7315092382398562_close,
      act_2248226175642056_setData_5756,
      evh_2248226175642056_selectedRowsChanged_5755,
      evh_2248226175642056_selectedRowsChanged,
      act_6466705138206980_showModal_5758,
      evh_6466705138206980_click_5757,
      evh_6466705138206980_click,
      act_8320016629450276_reloadSlickgrid_5762,
      evh_8320016629450276_success_5761,
      act_8320016629450276_request_5760,
      evh_8320016629450276_click_5759,
      evh_8320016629450276_click,
      deleteItems: act_8320016629450276_request_5760,
    }
  }
}

Vue.component("WorksheetList", WorksheetList);

</script>